import {combineReducers} from 'redux';

import {customerFileReducer } from './customerFileRed';
const reducer = combineReducers({
   customerFileReducer 
    });
    
    export default reducer;
